import { render, staticRenderFns } from "./PositioningForm.vue?vue&type=template&id=44bb1c7e&scoped=true"
import script from "./PositioningForm.vue?vue&type=script&lang=js"
export * from "./PositioningForm.vue?vue&type=script&lang=js"
import style0 from "./PositioningForm.vue?vue&type=style&index=0&id=44bb1c7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb1c7e",
  null
  
)

export default component.exports